import { Item } from '@components/select';
import { TableFilterTypeAheadFilterExtendedProps } from '@components/table/filters/TypeaheadFilterProps.type';
import { TextField } from '@components/textField';

import { Autocomplete } from '@mui/material';
import { useListWritingCompanies } from '@services/writingCompany';

export interface WritingCompanyTypeaheadFilterProps extends TableFilterTypeAheadFilterExtendedProps {}

export const WritingCompanyTypeaheadFilter = (componentProps: WritingCompanyTypeaheadFilterProps) => {
  const { value, disabled } = componentProps;

  const { writingCompanies } = useListWritingCompanies();

  const items =
    writingCompanies?.items?.map((ip) => {
      return {
        key: ip.id,
        value: ip.id,
        label: ip.name,
      };
    }) ?? [];

  return (
    <Autocomplete
      disabled={disabled || items.length === 0}
      key={`filter-writing-company-${componentProps.id}-${value ?? '0'}`}
      onChange={(_, value: any) => {
        componentProps.onChange(value);
      }}
      getOptionLabel={(option: Item | string) => {
        if (typeof option === 'string') {
          const selectedValue = items?.find((x: Item) => x.value === option);
          return selectedValue?.label ?? option;
        }
        return option.label;
      }}
      renderInput={(params: any) => <TextField {...params} inputLabel={componentProps.label ?? ''} />}
      value={value}
      options={(items ?? []).map((item) => ({
        label: item.label,
        value: item.value,
      }))}
      fullWidth
      isOptionEqualToValue={(option, value) => {
        return option === (value as unknown as string);
      }}
    />
  );
};
